import s from './style.module.scss';
import { useState } from 'react';

function StrictlyNecessaryModal({ setDetailModal }) {
  const [showDetail, setShowDetail] = useState(false);

  const handleBack = () => {
    if (showDetail) {
      setShowDetail(false);
    } else {
      setDetailModal(null);
    }
  };

  return (
    <>
      {showDetail ? (
        <>
          <div className={s.settings__title}>Name</div>
          <div className={s.settings__text}>G_ENABLED_IDPS</div>
          <div className={s.settings__title}>Description</div>
          <div className={s.settings__text}>Enables Duet members to login to our website via Google.</div>
          <div className={s.settings__title}>Type</div>
          <div className={s.settings__text}>Third Party</div>
          <div className={s.settings__title}>Host</div>
          <div className={s.settings__text}>google.com</div>
          <div className={s.settings__title}>Duration</div>
          <div className={s.settings__text}>unlimited</div>
          <div className={s.settings__title}>URL</div>
          <div className={s.settings__text}>
            <a href="https://developers.google.com/terms/api-services-user-data-policy">
              https://developers.google.com/terms/api-services-user-data-policy
            </a>
          </div>
          <div className={s.divider} />

          <div className={s.settings__title}>Name</div>
          <div className={s.settings__text}>NID</div>
          <div className={s.settings__title}>Description</div>
          <div className={s.settings__text}>Enables Duet members to login to our website via Google.</div>
          <div className={s.settings__title}>Type</div>
          <div className={s.settings__text}>Third Party</div>
          <div className={s.settings__title}>Host</div>
          <div className={s.settings__text}>google.com</div>
          <div className={s.settings__title}>Duration</div>
          <div className={s.settings__text}>6 months</div>
          <div className={s.settings__title}>URL</div>
          <div className={s.settings__text}>
            <a href="https://developers.google.com/terms/api-services-user-data-policy">
              https://developers.google.com/terms/api-services-user-data-policy
            </a>
          </div>
        </>
      ) : (
        <>
          <div className={s.settings__text}>
            These tools are necessary for the app to function and thus cannot be switched off. They are usually set in
            response to actions made by you which amount to a request for services, such as setting your privacy
            preferences, logging in or filling in forms.
          </div>
          <div className={s.settings__item}>
            <div>Google</div>
            <div className={s.button} onClick={() => setShowDetail(true)}>
              View Details
            </div>
          </div>
        </>
      )}
      <div className={s.backArrow} onClick={handleBack}>
        <div className={s.arrow} />
      </div>
    </>
  );
}

export default StrictlyNecessaryModal;
